import axios from 'axios';
import React, { useContext, useEffect, useState, useRef } from 'react'
import { toast } from 'react-toastify';
import { useDispatch, useSelector } from 'react-redux';

import authContext from '../context/authContext/authContext';
import RenderError from '../utils/RenderError';
import errorHandle from '../utils/errorHandle';
import successHandle from '../utils/successHandle';
import Loader from '../utils/Loader';
import { MIN_PAYOUT_TOKEN, MIN_REQUIRED_BALANCE } from '../utils/utils';
import moment from 'moment';
import PayoutStatus from '../utils/PayoutStatus';
import { getTokensAction } from '../redux/actions/tokensAction';

const PAYOUT_ENDPOINT = process.env.REACT_APP_API_URL + "/api/user/payout";
const GET_PAYOUTS_ENDPOINT = process.env.REACT_APP_API_URL + "/api/user/payouts";

const TOKEN_BUTTONS = [5000, 10000, 25000, 30000, 35000];

const Payouts = () => {
  const { getConfig } = useContext(authContext);
  const config = getConfig();
  const effectRan = useRef(false);
  const dispatch = useDispatch();

  const { user: currentUser } = useSelector((state) => state.user);
  const intialState = { tokens: 0, loading: false }
  const [state, setCompleteState] = useState(intialState)
  const setState = (newState) => setCompleteState((prevState) => ({ ...prevState, ...newState }))

  const getPayouts = async () => {
    setState({ loading: true });
    await axios.get(GET_PAYOUTS_ENDPOINT, config)
      .then((res) => setState({ payouts: res?.data?.payouts, loading: false }))
      .catch((error) => {
        setState({ loading: false });
        errorHandle(error)
      })
  }

  useEffect(() => {
    if (!effectRan.current) {
      getPayouts();

      return () => {
        effectRan.current = true;
      }
    }
  }, [])

  const handleSubmit = (e) => {
    e.preventDefault();
    const { tokens } = state;
    const { gdTokens } = currentUser;
    if (tokens < MIN_PAYOUT_TOKEN) {
      errorHandle(`Minimum payout token is ${MIN_PAYOUT_TOKEN}`)
      return;
    }

    if (tokens > gdTokens) {
      errorHandle('Insufficient GT!')
      return;
    }

    const maxPayableBalance = gdTokens - MIN_REQUIRED_BALANCE;
    if (tokens > maxPayableBalance) {
      errorHandle(`Minimum balance requirement is ${MIN_REQUIRED_BALANCE} the max payable amount is ${maxPayableBalance}`)
      return;
    }

    payout();
  }


  const getTokens = () => {
    dispatch(getTokensAction(config));
  };

  const payout = async () => {
    setState({ loading: true });
    const { tokens } = state;
    const data = { tokens };
    await axios.post(PAYOUT_ENDPOINT, data, config)
      .then((res) => {
        setState({ loading: false, tokens: 0 });
        successHandle(res.data.message)
      })
      .catch((err) => {
        setState({ loading: false });
        errorHandle(err)
      })

    getTokens();
    getPayouts();
  }

  const handleTokenClick = (tokens) => {
    setState({ tokens: tokens })
  };

  return (
    <div className='edit-profile-form container mb-5'>
      <div className='container pt-3'>
        <div className='pt-5'>
          <div className='section-title mt-5'>
            <p>Payouts</p>
            <div className=''>Unlock growth by partnering with us through a rewarding program offering shared opportunities, strong support, steady earnings, and long-term financial success together.</div>
          </div>

          <div className='text-center mb-4' hidden={!state.loading}>
            <Loader isLoading={state.loading} />
          </div>

          <div className='payouts' hidden={state.loading}>
            <div className='row'>
              <div className='col-md-6 pb-3'>
                <div className='card'>
                  <div className='card-body d-flex align-items-center justify-content-between py-2'>
                    <strong>Current GT</strong>
                    <div className='mt-2'>
                      <span className='mr-3'>{currentUser?.gdTokens}</span>
                      <img src="assets/img/gt-logo.png" style={{ zoom: 0.1 }} />
                    </div>
                  </div>
                  <div className='card-body d-flex align-items-center justify-content-between py-0'>
                    {/* <strong>Minimum Balance Requirement</strong> */}
                    <strong>
                      {/* for small screen & tablet */}
                      <span className="d-lg-none">Minimum Required</span>
                      {/* for big screen */}
                      <span className="d-none d-lg-inline">Minimum Balance Requirement</span>
                    </strong>
                    <div className='mt-2'>
                      <span className='mr-3'>{MIN_REQUIRED_BALANCE}</span>
                      <img src="assets/img/gt-logo.png" style={{ zoom: 0.1 }} />
                    </div>
                  </div>

                  <div className='card-body d-flex align-items-center justify-content-between py-2'>
                    <strong>Minimum Payout</strong>
                    <div className='mt-2'>
                      <span className='mr-3'>{MIN_PAYOUT_TOKEN}</span>
                      <img src="assets/img/gt-logo.png" style={{ zoom: 0.1 }} />
                    </div>
                  </div>
                </div>

              </div>
              <div className='col-md-6 pb-3'>
                <div className='card'>
                  <div className='card-body' style={{ paddingBlock: 10 }}>
                    <strong>Tokens</strong>
                    <div className="mt-2 d-flex align-items-center flex-wrap gap-2">
                      <input
                        type="number"
                        className="form-control"
                        style={{ maxWidth: 200 }}
                        min={0}
                        max={currentUser?.gdTokens}
                        placeholder="Enter tokens"
                        value={state?.tokens}
                        onChange={(e) => setState({ tokens: e.target.value })}
                        disabled={state.loading}
                      />
                      <button
                        type="button"
                        className="btn btn-primary fw-500"
                        disabled={state.loading || state.tokens < MIN_PAYOUT_TOKEN || currentUser?.gdTokens < MIN_REQUIRED_BALANCE}
                        onClick={handleSubmit}
                      >
                        Payout
                      </button>
                    </div>
                    <div className='my-2'>
                      {TOKEN_BUTTONS.map((token, index) => (
                        <button
                          key={token}
                          type="button"
                          className={`btn btn-sm btn-outline-secondary mx-2`}
                          onClick={() => handleTokenClick(token)}
                        >
                          {token / 1000}K
                        </button>
                      ))}

                    </div>
                  </div>
                </div>
              </div>
              <div className='col-12'>
                <div className='my-4' hidden={!state.payouts?.length}>
                  <div className='card'>
                    <div className='card-body' style={{ overflowX: 'auto', WebkitOverflowScrolling: 'touch' }}>
                      <table className="table table-hover text-center">
                        <thead>
                          <tr>
                            <th scope="col">Unique ID</th>
                            <th scope="col">GT</th>
                            <th scope="col">Amount</th>
                            <th scope="col">Status</th>
                            <th scope="col">Created</th>
                          </tr>
                        </thead>
                        <tbody>
                          {state?.payouts?.map((payout, i) => {
                            const { _id, tokens, status, amount, createdAt } = payout;
                            return (
                              <tr key={_id}>
                                <th>{_id}</th>
                                <td>{tokens}</td>
                                <td>{amount}</td>
                                <td>{<PayoutStatus status={status} />}</td>
                                <td>
                                  <div>{moment(createdAt).format("DD/MM/YYYY")}</div>
                                  <small className='text-muted'>{moment(createdAt).format("h:mm:ss a")}</small>
                                </td>
                              </tr>
                            )
                          })}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  )
}

export default Payouts
